export default __webpack_public_path__ + "static/media/eshop-video.f8982aae.mp4";